import React from 'react';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { loadChannelsExperience } from '@atlassian/jira-servicedesk-channels-jsd/src/experiences.tsx';
import { ChannelsJsdApp } from '@atlassian/jira-servicedesk-channels-jsd/src/index.tsx';
import { toProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { useUFOComponentExperience } from '@atlassian/ufo';
import { useSettingFeatures } from '../../../../controllers/features/main.tsx';

export const CustomerChannelsDialog = () => {
	useUFOComponentExperience(loadChannelsExperience);
	const { data: features } = useSettingFeatures();

	const projectContext = useResource(projectContextResource);
	const tenantContext = useTenantContext();
	if (!projectContext || !projectContext.data) return null;
	const { projectId, projectKey, isProjectAdmin, simplified } = projectContext.data;
	return (
		<>
			<ChannelsJsdApp
				locale={tenantContext.locale}
				projectId={toProjectId(String(projectId))}
				projectKey={projectKey}
				environment={tenantContext.environment || 'prod'}
				isProjectAdmin={isProjectAdmin || false}
				isProjectSimplified={simplified}
				isJSMChatInstalled={!!features?.hasChat}
			/>
		</>
	);
};
